// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uokH4P {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.WoD0RN {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.dwY9wd {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  margin: 0;
}

.FGCp2O {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  max-width: 520px;
}

.ci5V3x {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-1);
}

.U_qfcE {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.c2GEwJ {
  color: var(--text-neutral-stronger);
}

.ZJUDI5 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
}

.RcwiBK {
  background: none;
  border: none;
  padding: 0;
  cursor: help;
  display: inline-flex;
  align-items: center;
}

.ACPHFh {
  width: 12px;
  height: 12px;
  color: var(--text-neutral-stronger);
}

.ByXgTD {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  width: 100%;
  padding: 12px 20px;
  border: 1px solid var(--stroke-neutral-subtle);
  background: var(--surface-neutral-pale);
  border-radius: var(--radius-s);
  box-sizing: border-box;
}

.JKfC5B {
  opacity: 0.6;
  border: none;
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular);
  background-color: transparent;
  outline: none;
  width: 100%;
}

.mans2W {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.pfZjEH {
  width: 16px;
  height: 16px;
  color: var(--text-neutral-stronger);
}

.cNfBtP {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-3);
  width: 520px;
  max-width: 100%;
}

.ysRZ86 {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
  background: var(--surface-neutral-pale);
  border: none;
  border-radius: var(--radius-s);
  cursor: pointer;
  font-family: var(--font-family-base);
  text-align: left;
  box-sizing: border-box;
}

.ysRZ86:focus-within {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
}

.yrrfpe {
  background: var(--surface-primary-subtle);
}

.VXo9TY {
  width: 16px;
  height: 16px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--stroke-neutral-dark);
  background: var(--surface-neutral-white);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
}

.aeC5bJ {
  border-color: var(--surface-primary-medium);
  background: var(--surface-primary-medium);
}

.aeC5bJ::after {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: var(--radius-pill);
  background: var(--surface-neutral-white);
}

.B3p2TG {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.pEJTSv {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  max-width: 520px;
}

.aMlWMG {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 520px;
  max-width: 100%;
}

.lPn1BS {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  margin: 0;
}

.NbymOE {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-3);
}

.XX_QAk {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.Qv4mB0 {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-1);
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-family-base);
  text-align: left;
}

.xNUhNm {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.Qv4mB0:focus-within {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
}

.j4wEUF {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/GlobalSettings/GlobalSettingsNew.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,uCAAuC;EACvC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,uCAAuC;EACvC,6BAA6B;EAC7B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,uCAAuC;EACvC,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,4CAA4C;EAC5C,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.mandatoryLegend {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.subtitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.fieldGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  max-width: 520px;\n}\n\n.labelRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.labelText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.requiredAsterisk {\n  color: var(--text-neutral-stronger);\n}\n\n.helperText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n}\n\n.infoButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: help;\n  display: inline-flex;\n  align-items: center;\n}\n\n.infoIcon {\n  width: 12px;\n  height: 12px;\n  color: var(--text-neutral-stronger);\n}\n\n.dateInputRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  width: 100%;\n  padding: 12px 20px;\n  border: 1px solid var(--stroke-neutral-subtle);\n  background: var(--surface-neutral-pale);\n  border-radius: var(--radius-s);\n  box-sizing: border-box;\n}\n\n.dateInput {\n  opacity: 0.6;\n  border: none;\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular);\n  background-color: transparent;\n  outline: none;\n  width: 100%;\n}\n\n.calendarButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.calendarIcon {\n  width: 16px;\n  height: 16px;\n  color: var(--text-neutral-stronger);\n}\n\n.calculationGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-3);\n  width: 520px;\n  max-width: 100%;\n}\n\n.calculationCard {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n  background: var(--surface-neutral-pale);\n  border: none;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.calculationCard:focus-within {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n}\n\n.calculationCardSelected {\n  background: var(--surface-primary-subtle);\n}\n\n.calculationRadio {\n  width: 16px;\n  height: 16px;\n  border-radius: var(--radius-pill);\n  border: 1px solid var(--stroke-neutral-dark);\n  background: var(--surface-neutral-white);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.calculationRadioSelected {\n  border-color: var(--surface-primary-medium);\n  background: var(--surface-primary-medium);\n}\n\n.calculationRadioSelected::after {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: var(--radius-pill);\n  background: var(--surface-neutral-white);\n}\n\n.calculationLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.payrollSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  max-width: 520px;\n}\n\n.payrollHeader {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 520px;\n  max-width: 100%;\n}\n\n.payrollTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.discountRadioGroup {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-3);\n}\n\n.discountInputWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.discountRadio {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  text-align: left;\n}\n\n.discountRadioLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.discountRadio:focus-within {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n}\n\n.visuallyHiddenInput {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `uokH4P`,
	"mandatoryLegend": `WoD0RN`,
	"subtitle": `dwY9wd`,
	"fieldGroup": `FGCp2O`,
	"labelRow": `ci5V3x`,
	"labelText": `U_qfcE`,
	"requiredAsterisk": `c2GEwJ`,
	"helperText": `ZJUDI5`,
	"infoButton": `RcwiBK`,
	"infoIcon": `ACPHFh`,
	"dateInputRow": `ByXgTD`,
	"dateInput": `JKfC5B`,
	"calendarButton": `mans2W`,
	"calendarIcon": `pfZjEH`,
	"calculationGrid": `cNfBtP`,
	"calculationCard": `ysRZ86`,
	"calculationCardSelected": `yrrfpe`,
	"calculationRadio": `VXo9TY`,
	"calculationRadioSelected": `aeC5bJ`,
	"calculationLabel": `B3p2TG`,
	"payrollSection": `pEJTSv`,
	"payrollHeader": `aMlWMG`,
	"payrollTitle": `lPn1BS`,
	"discountRadioGroup": `NbymOE`,
	"discountInputWrapper": `XX_QAk`,
	"discountRadio": `Qv4mB0`,
	"discountRadioLabel": `xNUhNm`,
	"visuallyHiddenInput": `j4wEUF`
};
module.exports = ___CSS_LOADER_EXPORT___;
